const Logo = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Footer = () => {
  return (
    <>
      <footer className="bg-gray-50 text-gray-600 py-16 border-t border-gray-200 relative overflow-hidden">
        {/* Subtle patterned background - very low opacity for light theme */}
        <div className="absolute inset-0 bg-cover bg-center opacity-[0.03] pointer-events-none" style={{ backgroundImage: "url('/assets/feature-bg.png')" }}></div>

        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-12 relative z-10">
          {/* Column 1: Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <div className="p-1.5 rounded-lg bg-blue-600 flex items-center justify-center">
                <Logo className="h-6 w-6 text-white" />
              </div>
              <span className="text-2xl font-bold text-gray-900">Quick Hire</span>
            </div>
            <p className="text-gray-500 mb-6 leading-relaxed">
              The smartest way to build your professional resume. Fast, easy, and effective.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors" aria-label="Twitter">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" /></svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors" aria-label="LinkedIn">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" /><rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" /></svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-600 transition-colors" aria-label="Instagram">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" /></svg>
              </a>
            </div>
          </div>

          {/* Column 2: Product */}
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-6">Product</h3>
            <ul className="space-y-4">
              <li><a href="/" className="hover:text-blue-600 transition-colors">Home</a></li>
              <li><a href="/#features" className="hover:text-blue-600 transition-colors">Features</a></li>
              <li><a href="/#pricing" className="hover:text-blue-600 transition-colors">Pricing</a></li>
              <li><a href="/dashboard" className="hover:text-blue-600 transition-colors">Templates</a></li>
            </ul>
          </div>

          {/* Column 3: Support */}
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-6">Support</h3>
            <ul className="space-y-4">
              <li><a href="/#faq" className="hover:text-blue-600 transition-colors">Help Center</a></li>
              <li><a href="/privacy-policy" className="hover:text-blue-600 transition-colors">Privacy Policy</a></li>
              <li><a href="/refund-policy" className="hover:text-blue-600 transition-colors">Refund Policy</a></li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-6">Contact</h3>
            <div className="space-y-4 text-gray-500">
              <p>
                R802, North Wall, <br />
                Dublin, Ireland<br />
              </p>
              <p>RC: 7891193</p>
              <a href="tel:+353832007206" className="block hover:text-blue-600 transition-colors">+35383 200 7206</a>
            </div>
          </div>

        </div>
        <div className="max-w-7xl mx-auto px-6 mt-16 pt-8 border-t border-gray-200 text-center text-gray-400">
          <p>© {new Date().getFullYear()} Famad Network International. All rights reserved.</p>
        </div>
      </footer>


    </>
  )
}

export default Footer;